/*
 * DrillListTitle
 *
 * Title row directly above the scrolling drill list ("Vessels" / "Voyages" /
 * "Routes").
 */

import React from "react";
import { Box, Typography } from "@mui/material";
import { PANEL_SUBTITLE_SX } from "@/theme/panelStyles";
import { PANEL_CARD_BORDER } from "@/theme/tokens";

export default function DrillListTitle({ title }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        minHeight: 24,
        px: 0.5,
        pb: 0.5,
        mb: 0.75,
        borderBottom: `1px solid ${PANEL_CARD_BORDER}`,
      }}
    >
      <Typography sx={PANEL_SUBTITLE_SX}>{title}</Typography>
    </Box>
  );
}
